import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Ninetenththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Rose Gold */
            --primary: #be185d;       /* Pink 700 */
            --primary-light: #fbcfe8; /* Pink 200 */
            --accent: #d4af37;        /* Gold */
            --bg-body: #fff1f2;       /* Rose 50 */
            --bg-white: #ffffff;
            --text-main: #881337;     /* Rose 900 */
            
            --font-head: 'Playfair Display', serif;
            --font-body: 'Lora', serif;
        }

        body { font-family: var(--font-body); background-color: var(--bg-body); color: var(--text-main); margin: 0; line-height: 1.8; }
        h1, h2, h3, h4 { font-family: var(--font-head); font-weight: 700; color: var(--primary); }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 30px; }
        
        .btn { display: inline-block; padding: 12px 30px; background: var(--primary); color: white; border: 1px solid var(--primary); font-family: var(--font-body); letter-spacing: 1px; cursor: pointer; transition: 0.3s; }
        .btn:hover { background: white; color: var(--primary); }
        
        .top-nav { padding: 30px 0; text-align: center; border-bottom: 1px solid #fed7aa; }
        .logo { font-size: 2.5rem; letter-spacing: 2px; color: var(--text-main); text-transform: uppercase; }
        
        .hero { padding: 100px 0; text-align: center; position: relative; overflow: hidden; }
        .hero::after { content: ''; position: absolute; width: 600px; height: 600px; background: radial-gradient(circle, rgba(251,207,232,0.5) 0%, transparent 70%); top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: -1; }
        .hero h1 { font-size: 4rem; font-style: italic; margin-bottom: 20px; }
        
        .divider { width: 60px; height: 2px; background: var(--accent); margin: 30px auto; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 40px; }
        .card { background: white; padding: 40px; text-align: center; border: 1px solid #fecdd3; transition: 0.4s; }
        .card:hover { border-color: var(--accent); box-shadow: 0 10px 30px rgba(190, 24, 93, 0.05); }
        
        .icon-circle { width: 70px; height: 70px; border: 1px solid var(--accent); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; font-size: 1.5rem; color: var(--primary); }
        
        .product-img { height: 250px; overflow: hidden; margin-bottom: 20px; position: relative; }
        .product-img img { width: 100%; height: 100%; object-fit: cover; }
        
        .footer { background: white; border-top: 1px solid #fecdd3; padding: 60px 0; text-align: center; margin-top: 80px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Lora:ital,wght@0,400;0,600;1,400&family=Playfair+Display:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" />

            <div className="top-nav">
                <div className="container">
                    <div className="logo">{get_data.service_name}</div>
                    <div style={{marginTop: '20px', display: 'flex', justifyContent: 'center', gap: '30px', fontFamily: 'var(--font-head)', fontStyle: 'italic'}}>
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Collection</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </div>

            <div className="hero">
                <div className="container">
                    <h1>Elegance & Beauty</h1>
                    <div className="divider"></div>
                    <p style={{fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto 40px'}}>Discover a world where quality meets sophistication. We curate experiences that linger in memory.</p>
                    <a href="#products" className="btn">View Collection</a>
                </div>
            </div>

            <div className="section" id="services" style={{padding: '80px 0'}}>
                <div className="container">
                    <h2 style={{textAlign: 'center', fontSize: '3rem', marginBottom: '60px'}}>Our Craft</h2>
                    <div className="grid">
                        {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="card" key={index}>
                                <div className="icon-circle">
                                     {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover'}} alt=""/> : <span>✾</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <p style={{color: '#9f1239', fontSize: '0.95rem'}}>{item.description}</p>
                                <a href="#contact" style={{display: 'inline-block', marginTop: '20px', borderBottom: '1px solid var(--primary)', paddingBottom: '2px'}}>Enquire</a>
                            </div>
                        )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                    </div>
                </div>
            </div>

            <div className="section" id="products" style={{background: 'white', padding: '80px 0'}}>
                <div className="container">
                     <h2 style={{textAlign: 'center', fontSize: '3rem', marginBottom: '60px'}}>The Collection</h2>
                     <div className="grid">
                         {get_data.product_services && get_data.product_services.map((item, index) => (
                            <div className="card" key={index} style={{padding: '20px'}}>
                                <div className="product-img">
                                    {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} alt={item.service_name}/>) : (<div className="" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                                </div>
                                <h3 style={{fontSize: '1.5rem'}}>{item.service_name}</h3>
                                {item.price && <div style={{color: 'var(--accent)', fontSize: '1.2rem', margin: '10px 0', fontFamily: 'var(--font-head)'}}>₹{item.price}</div>}
                                <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', marginTop: '15px'}}>Add to Bag</button>
                            </div>
                         ))}
                     </div>
                </div>
            </div>
            <div className="section" id="categories" style={{padding: '80px 0'}}>
                <div className="container">
                     <h2 style={{textAlign: 'center', fontSize: '3rem', marginBottom: '60px'}}>Categories</h2>
                     <div className="grid">
                         {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                            <div className="card" key={index} style={{textAlign: 'center'}}>
                                <div className="icon-circle">
                                     {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover'}} alt=""/> : <span>✾</span>}
                                </div>
                                <h3>{item.name}</h3>
                                <div style={{display: 'flex', gap: '10px', justifyContent: 'center', marginTop: '20px'}}>
                                    <a href={`tel:${get_data.mobile}`} className="btn" style={{padding: '8px 20px', background: 'transparent', color: 'var(--primary)', fontSize: '0.9rem'}}>Call</a>
                                    <a href="#contact" className="btn" style={{padding: '8px 20px', fontSize: '0.9rem'}}>Enquiry</a>
                                </div>
                            </div>
                         )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                     </div>
                </div>
            </div>
            <div className="footer" id="contact">
                <div className="container">
                    <h2 style={{fontSize: '2rem', marginBottom: '20px'}}>{get_data.service_name}</h2>
                    <p>{get_data.business_location_name}</p>
                    <p style={{fontStyle: 'italic', marginTop: '10px'}}>{get_data.email} — {get_data.mobile}</p>
                    <div style={{marginTop: '40px', borderTop: '1px solid #eee', paddingTop: '20px', fontSize: '0.8rem'}}>
                        &copy; {new Date().getFullYear()} All rights reserved.
                    </div>
                </div>
            </div>
        </>
    );
};

export default Ninetenththeme;
